import { deleteAsync, getAsync, postAsync, putAsync } from '../api.service'

// Direct calls to rapid-api-auth for the SSO pages that need a query string
// built per request (filters, paging cursors). useApiList freezes its
// endpoint when it mounts and joins get(arg) as `${endpoint}/${arg}`, so a
// filter would become "auth-policy-finding/?rule=…". These resolve to the
// response body and, on failure, throw the response ({ status, data }) the
// same way the api-new hooks do, so serverMessage(err) reads data.message.
const base = () => process.env.REACT_APP_API_AUTH

const unwrap = async call => {
  try {
    const result = await call()
    return result ? result.data : undefined
  } catch (err) {
    throw (err && err.response) || err
  }
}

// { key: value } to "?key=value&…", skipping empty values.
export const queryString = params => {
  const search = new URLSearchParams()
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return
    search.set(key, String(value))
  })
  const text = search.toString()
  return text ? `?${text}` : ''
}

export const authGet = (path, params) => unwrap(() => getAsync(base(), `api/v1/${path}${queryString(params)}`))
export const authPut = (path, body) => unwrap(() => putAsync(base(), `api/v1/${path}`, body))
export const authPost = (path, body) => unwrap(() => postAsync(base(), `api/v1/${path}`, body))
export const authDelete = path => unwrap(() => deleteAsync(base(), `api/v1/${path}`))

// Clears the sign-in identity recorded for a login at one connection ({ cleared }); the next sign-in records anew.
export const clearSsoIdentity = (loginID, providerID) => authDelete(`sso-identity/${encodeURIComponent(loginID)}/${encodeURIComponent(providerID)}`)
